import { useQuery } from '@tanstack/react-query';
import { getReviewId } from 'query/review';
import {
  getExclusionReasons,
  ExclusionReasonWithPosition,
} from 'query/review/ExclusionReasons';

function isExclusionReasonsModified(
  exclusionReasons: ExclusionReasonWithPosition[] = [],
  defaults: string[] = []
): boolean {
  if (exclusionReasons.length !== defaults.length) return true;
  if (exclusionReasons.some((r) => !defaults.includes(r.reason))) return true;

  return exclusionReasons.some((r) => r.position !== null);
}

type UseExclusionReasonsResult = {
  isLoading: boolean;
  exclusionReasons: ExclusionReasonWithPosition[] | undefined;
  isSortedOrModified: boolean;
};

export function useExclusionReasons(): UseExclusionReasonsResult {
  const reviewId = getReviewId() || '';

  const { isFetching, data } = useQuery({
    queryKey: ['exclusionReasons', reviewId],
    queryFn: getExclusionReasons,
    staleTime: 60_000,
  });

  const defaults = data?.default_names;
  const exclusionReasons = data?.exclusion_reasons;

  return {
    isLoading: isFetching,
    exclusionReasons,
    isSortedOrModified: isExclusionReasonsModified(exclusionReasons, defaults),
  };
}
